var _rect, _g, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 130,
    height: 130,
    rx: 65,
    fill: "#1BC5A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1328_49234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.5647 76.2927L88.8725 76.2927L88.8725 74.6005L88.8725 48.5462L81.2181 56.2006L81.2181 83.9414L107.994 83.9414L108 29.4187L100.346 37.0731L100.346 74.6005L100.346 76.2927L98.6534 76.2927L90.5647 76.2927Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3984 46.1269L58.7062 46.1269L58.7062 44.4347L58.7062 36.3459L58.7062 34.6537L60.3984 34.6537L94.0337 34.6537L101.688 26.9994L51.0575 27.005L51.0575 53.7812L74.9062 53.7812L82.5606 46.1269L60.3984 46.1269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6488 77.5418L34.6488 75.8496L36.3409 75.8496L52.8399 75.8496L60.4887 68.2008L27 68.2008L27 101.689L34.6487 94.0407L34.6488 77.5418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0686 100.351L29.4198 108L66.8005 108L66.8005 70.6193L59.1518 78.268L59.1518 98.6591L59.1518 100.351L57.4596 100.351L37.0686 100.351Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 130,
    height: 130,
    rx: 65,
    stroke: "white",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1328_49234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 81,
    height: 81,
    fill: "white",
    transform: "translate(108 108) rotate(-180)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessLogo);
export default __webpack_public_path__ + "static/media/BusinessLogo.1d9554c3bab35ca3f399cc9e60ad7593.svg";
export { ForwardRef as ReactComponent };